import { SupportedCurrencies } from '@shared/types';
import { renderPrice } from '../renderPrice';

export const renderPriceOrFree = (price: number, currency?: SupportedCurrencies): string => {
    if (price === 0 || price === null) {
        return 'Free';
    }
    return renderPrice(price, currency);
};
